const mobilePageGradients = [
  // { page: '1' },
];

export default mobilePageGradients;